import actions from "./actions";

const randomize = {
  actions,
  namespaced: true,
}
export default randomize;